const exchangeRatesApi = '/exchange-rates';

export const getExchangeRateApiPath = () => `${exchangeRatesApi}`;
